import { Box, Container, Dialog, Slide } from '@mui/material';
import { WbIcon, WbRoundButton } from '@workbench/react';
import { TransitionProps } from 'notistack';
import { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslationContext } from '../../common/i18n/TranslationProvider';
import { FillHeight } from '../../utils/fillHeight';
import { useClientCompanyRegistrationContext } from '../client/companyRegistration/context/ClientCompanyRegistrationContext';
import { useContentRefContext } from '../contexts/ContentRefProvider';
import { getUmasLink } from '../../configuration/confUtils';

const useStyles = makeStyles<{ appbarSize: number }>()((theme, { appbarSize }) => ({
    dialog: {
        zIndex: 0,
        marginTop: appbarSize,
    },
    closeIcon: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
    },
}));

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement<unknown>;
        },
        ref: React.Ref<unknown>
    ) => {
        return <Slide direction="up" ref={ref} {...props} />;
    }
);

export default function UmasOverlay() {
    const { appbarSize } = useContentRefContext();
    const { classes } = useStyles({ appbarSize });
    const { langState } = useTranslationContext();
    const { isUmasRegistrationModalOpen, setIsUmasRegistrationModalOpen } = useClientCompanyRegistrationContext();

    const getUmasLinkWithLang = () => {
        return `${getUmasLink()}&lang=${langState}`;
    };
    const handleClose = () => {
        setIsUmasRegistrationModalOpen(false);
    };

    return (
        <Dialog
            className={classes.dialog}
            fullScreen
            open={isUmasRegistrationModalOpen}
            onClose={handleClose}
            slots={{
                transition: Transition,
            }}
        >
            <Container>
                <div className={classes.closeIcon}>
                    <WbRoundButton size="m" buttonAriaLabel="closeUmas" onClick={handleClose}>
                        <WbIcon name="close/24"></WbIcon>
                    </WbRoundButton>
                </div>

                <FillHeight>
                    {(restHeight) => (
                        <Box sx={{ height: restHeight - 6 }}>
                            <div style={{ height: '100%' }}>
                                <iframe
                                    src={getUmasLinkWithLang()}
                                    sandbox="allow-scripts allow-same-origin allow-downloads"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none' }}
                                    title="UMAS Signup"
                                />
                            </div>
                        </Box>
                    )}
                </FillHeight>
            </Container>
        </Dialog>
    );
}
